module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/LeaveRequestModal/Cancelation.ejs -->\n<div>\n    <strong>Cancelled by:\n        '+
((__t=( model.get('canceledByName') || '-' ))==null?'':_.escape(__t))+
'\n    </strong>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/LeaveRequestModal/Cancelation.ejs
// module id = 899
// module chunks = 1